import { useAppStore } from '@/store/appStore';
import { useViewData } from './useViewData';

/**
* Hook per la Deviations View.
* 
* Wrapper di useViewData che aggiunge la logica specifica per deviations:
* - Filtri per groupBy, filter e assignee
* - Gestione del click sui task (seleziona task e cambia vista a 'list')
* 
* @note Questo è un wrapper semplice di useViewData. Se la logica rimane semplice,
* potrebbe essere integrato direttamente nel componente DeviationsView per ridurre l'indirection.
* Tuttavia, mantenerlo separato è utile se la logica potrebbe crescere in futuro.
* 
* @returns Oggetto con i dati e le funzioni per la deviations view
* @returns tasks - Task filtrati da useViewData
* @returns groupBy - Modalità di raggruppamento corrente
* @returns filter - Filtro corrente
* @returns assigneeFilter - Filtro per assignee corrente
* @returns onGroupByChange - Funzione per cambiare il raggruppamento
* @returns onFilterChange - Funzione per cambiare il filtro
* @returns onAssigneeFilterChange - Funzione per cambiare il filtro assignee
* @returns onTaskClick - Funzione chiamata quando si clicca su un task
*/
export function useDeviationsView() {
  const viewData = useViewData();

  const deviationGroupBy = useAppStore((state) => state.deviationGroupBy);
  const deviationFilter = useAppStore((state) => state.deviationFilter);
  const deviationAssignee = useAppStore((state) => state.deviationAssignee);
  const setDeviationGroupBy = useAppStore((state) => state.setDeviationGroupBy);
  const setDeviationFilter = useAppStore((state) => state.setDeviationFilter);
  const setDeviationAssignee = useAppStore((state) => state.setDeviationAssignee);
  const setViewMode = useAppStore((state) => state.setViewMode);
  const selectTask = useAppStore((state) => state.selectTask);

  const handleTaskClick = (taskId: string) => {
  selectTask(taskId);
  setViewMode('list');
  };

  return {
  tasks: viewData.tasks,
  groupBy: deviationGroupBy,
  filter: deviationFilter,
  assigneeFilter: deviationAssignee,
  onGroupByChange: setDeviationGroupBy,
  onFilterChange: setDeviationFilter,
  onAssigneeFilterChange: setDeviationAssignee,
  onTaskClick: handleTaskClick,
  };
}

